import React from "react"
import { Container, FlexContainer } from "@carrotfertility/carotene"

type CaseRateRenewalModalButtonGroupProps = {
  buttonOne: React.ReactElement
  buttonTwo: React.ReactElement
  heightFromBottom?: number[]
}

export function CaseRateRenewalModalButtonGroup({
  buttonOne,
  buttonTwo,
  heightFromBottom = [24, 48]
}: CaseRateRenewalModalButtonGroupProps): JSX.Element {
  return (
    <FlexContainer sx={{ marginTop: heightFromBottom }} justifyContent="flex-end">
      <FlexContainer
        direction={["column", "row"]}
        alignItems={"end"}
        sx={{ position: "relative", right: [0, 0], bottom: heightFromBottom }}
      >
        <Container sx={{ marginBottom: [16, 0] }}>{buttonOne}</Container>
        <Container sx={{ marginLeft: [0, 24] }}>{buttonTwo}</Container>
      </FlexContainer>
    </FlexContainer>
  )
}
